import FCellBtnLinkMDP from "@/components/table/cell/FCellBtnLinkMDP";
import FDataTableMDP, { ActionType } from "@/components/table/FDataTableMDP";
import * as Data from "@/../src-gen/data";
import { BooleanCellType } from "@/components/table/cell/FCellBooleanMDP";


export default class PaymentRequestListFDataTableMDP extends FDataTableMDP {
    parent: any;

    constructor({ parent }: { parent: any }) {
        super({
            myRefName: "PaymentRequestListFDataTableRef",
            title: "Payment Request List",
            itemKey: "paymentRequestId",
            showFiltersByDefault: false
        })
        this.parent = parent;

        this.addColumn({
            label: "Payment Req Number",
            dataSelectorKey: "paymentReqNumber",
            // columnCellMDP: new FCellRouterLinkMDP({
            //     queryList: [
            //         { queryKey: "paymentRequestId", queryName: "paymentRequestId" },
            //     ],
            // }),
            enableCopy: true,
            copyTooltipText: "Copy",
            dataSelectorKeyToCopy: "paymentReqNumber",
            width: "18%",
        })
        .addColumn({
            label: "PG Link",
            dataSelectorKey: "freedPGLink",
            columnCellMDP: new FCellBtnLinkMDP({
                label: "PG Link",
                color: "primary",
                onClick: (item) => {
                    console.log("item", item);
                },
            }),
        })
        .addStatusColumn({
            label: "Payment Mode",
            dataSelectorKey: "paymentMode.name",
        })
        .addStatusColumn({
            label: "Payment Provider",
            dataSelectorKey: "paymentProvider.name",
            //  filterItemList: Data.Payment.PAYMENT_PROVIDER.list(),
        })
        .addStatusColumn({
            label: "From Account Entity",
            dataSelectorKey: "fromAccountEntity.name",
        })
        .addStatusColumn({
            label: "To Account Entity",
            dataSelectorKey: "toAccountEntity.name",
        })
        .addCurrencyColumn({
            label: "Amount",
            dataSelectorKey: "amount",
        })
        .addDateColumn({
            label: "Drafted Date",
            dataSelectorKey: "draftedOn",
            hidden: true
        })
        .addDateColumn({
            label: "Scheduled Date",
            dataSelectorKey: "scheduledDate",

        })
        .addDateColumn({
            label: "Settled Date",
            dataSelectorKey: "settledDate",
            hidden: true,
        })
        .addStatusColumn({
            label: "Status",
            dataSelectorKey: "paymentReqStatus.name",
            // colorCodeData: Data.Color.PAYMENT_REQ_STATUS,
            outlined: true,
            filterItemList: Data.Payment.PAYMENT_REQ_STATUS.list(),
            enableHeaderFilter: false,
        })
        .addColumn({
            label: "Remote Payment Reference Number",
            dataSelectorKey: "remotePaymentReferenceNumber",
            hidden: true,
        })
        .addColumn({
            label: "Parent Payment Reference Number",
            dataSelectorKey: "parentPaymentReferenceNumber",
            hidden: true,
        })
        .addStatusColumn({
            label: "Txn Purpose",
            dataSelectorKey: "txnPurpose.name",
            outlined: true,
            hidden: true
        })
        .addBooleanColumn({
            label: "",
            dataSelectorKey: "isOnboardingDiscountApplied",
            type: BooleanCellType.BoldText,
            hideFalseValue: true,
            successText: "D"


        })
        .addStatusColumn({
            label: "Initiated by",
            dataSelectorKey: "whoDidIt",
            hidden: true
        })

        .addColumn({
            label: "Remarks",
            dataSelectorKey: "remarks",
            hidden: true,
        })
        .addColumn({
            label: "Failure Reason",
            dataSelectorKey: "failureReason",
            hidden: true,
        })
        .addColumn({
            label: "Provider PGL ink",
            dataSelectorKey: "providerPGLink",
            hidden: true,
        })
        .addAction({
            label: "Refresh",
            onClick: (item, index) => {
                return new Promise((res) => {
                    this.parent.getSPAPaymentRequestsList();
                });
            },
            type: ActionType.REFRESH,
        })

    }

}